import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import Layout, { Container } from "../components/layout";
import { apiurl } from "../config/config";
import { getCookie } from "../config/webStorage";

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [dates, setDates] = useState({ startDate: "", endDate: "" });
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    limit: 100,
  });
  const swtoken = getCookie("swtoken");

  const fetchOrders = async (page = 1) => {
    try {
      const params = {
        page,
        limit: pagination.limit,
      };

      if (dates.startDate) params.startDate = dates.startDate;
      if (dates.endDate) params.endDate = dates.endDate;

      const { data } = await axios.get(`${apiurl}/api/order/get`, {
        params,
        headers: {
          Authorization: swtoken,
          "Content-Type": "application/json",
        },
      });

      setOrders(data.orders);
      setPagination((prev) => ({
        ...prev,
        currentPage: data.currentPage,
        totalPages: data.totalPages,
      }));
    } catch (err) {
      console.error("Error fetching orders:", err);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        <div className="p-6">
          <h2 className="text-2xl font-bold mb-4">Order List</h2>

          <div className="flex gap-4 mb-4 items-center">
            <input
              type="date"
              className="border p-2 rounded"
              value={dates.startDate}
              onChange={(e) =>
                setDates({ ...dates, startDate: e.target.value })
              }
            />
            <input
              type="date"
              className="border p-2 rounded"
              value={dates.endDate}
              onChange={(e) => setDates({ ...dates, endDate: e.target.value })}
            />
            <button
              className="bg-blue-600 text-white px-4 py-2 rounded"
              onClick={() => fetchOrders(1)}
            >
              Filter
            </button>
          </div>

          <div className="overflow-auto">
            <table className="min-w-full border">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border px-4 py-2">Order No</th>
                  <th className="border px-4 py-2">Customer</th>
                  <th className="border px-4 py-2">Phone</th>
                  <th className="border px-4 py-2">Total</th>
                  <th className="border px-4 py-2">Date</th>
                  <th className="border px-4 py-2">Status</th>
                </tr>
              </thead>
              <tbody>
                {orders.map((order) => (
                  <tr key={order._id}>
                    <td className="border px-4 py-2">{order.order_number}</td>
                    <td className="border px-4 py-2">
                      {order.billing_address?.name}
                    </td>
                    <td className="border px-4 py-2">
                      {order.billing_address?.phone}
                    </td>
                    <td className="border px-4 py-2">₹{order.total_price}</td>
                    <td className="border px-4 py-2">
                      {moment(order.processed_at).format("DD MMM YYYY")}
                    </td>
                    <td className="border px-4 py-2 capitalize">
                      {order.financial_status || "N/A"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination Controls */}
          <div className="flex justify-center mt-4 gap-2">
            <button
              disabled={pagination.currentPage === 1}
              onClick={() => fetchOrders(pagination.currentPage - 1)}
              className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
            >
              Prev
            </button>
            <span className="px-4 py-2">
              Page {pagination.currentPage} of {pagination.totalPages}
            </span>
            <button
              disabled={pagination.currentPage === pagination.totalPages}
              onClick={() => fetchOrders(pagination.currentPage + 1)}
              className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
            >
              Next
            </button>
          </div>
        </div>
      </Container>
    </Layout>
  );
};

export default Orders;